var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-container"},[(_vm.data.index_html)?_c('iframe',{staticClass:"widget-iframe",style:(_vm.elementStyle),attrs:{"src":_vm.iframeSrc,"sandbox":"allow-scripts allow-same-origin","scrolling":"no"}}):_c('img',{staticClass:"widget-background-image",attrs:{"src":_vm.data.background_image,"alt":"Widget Thumbnail"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }